var _defs, _path, _path2, _circle, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.68,27.05c-.25,0-.5-.08-.72-.23l-11.89-8.92c-.43-.31-.61-.86-.44-1.36.16-.5.63-.84,1.16-.84h23.78c.53,0,1,.34,1.16.84.16.5-.02,1.05-.44,1.36l-11.89,8.92c-.21.16-.46.23-.72.23Zm-8.15-8.92l8.15,6.2,8.15-6.2h-16.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.57,34.83H12.79c-.67,0-1.22-.55-1.22-1.22v-16.71c0-.67.55-1.22,1.22-1.22s1.22.55,1.22,1.22v15.49h21.35v-7.73c0-.67.55-1.22,1.22-1.22s1.22.55,1.22,1.22v8.95c0,.67-.55,1.22-1.22,1.22Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.79,
    cy: 17,
    r: 1.83
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.57 20.37 39.05 26.43 36.57 24.99 34.09 26.43 36.57 20.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBlue);
export default __webpack_public_path__ + "static/media/message_blue.9b4d5190060b38b7f65420dae39047f2.svg";
export { ForwardRef as ReactComponent };